import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"spinner",attrs:{"icon":"","small":""}},[_c(VIcon,{attrs:{"size":"16"}},[_vm._v("mdi-cog")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }